const guiColors = {
    'motion-primary': '#d415ff',
    'motion-primary-transparent': 'hsla(289, 100%, 54%, 0.35)',
    'motion-tertiary': '#a300c7',

    'looks-secondary': '#d415ff',
    'looks-secondary-light': '#df4eff',
    'looks-secondary-lighter': '#e892fb',
    'looks-transparent': 'hsla(289, 100%, 39%, 0.15)',
    'looks-light-transparent': '#FF4DC126',
    'looks-secondary-dark': '#58039c',
    'looks-secondary-darker': '#360160',
    'looks-secondary-deep-dark': '#1d0133',

    'extensions-primary': '#d415ff',
    'extensions-tertiary': '#a300c7',
    'extensions-transparent': 'hsla(289, 100%, 54%, 0.35)',
    'extensions-light': '#df4eff',

    'drop-highlight': '#e670ff'
};

const blockColors = {
    checkboxActiveBackground: '#d415ff',
    checkboxActiveBorder: '#a509c8'
};

export {
    guiColors,
    blockColors
};